import { FullMetadata, getDownloadURL, getMetadata, listAll, ref } from "firebase/storage";
import { auth, storage } from "../../firebase";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { SelectFields } from "../../components/select/SelectFields";
import { RadioButton, RadioButtonItem } from "../../components/radiobutton/RadioButton";
import { useInput } from "../../hooks/useInput";
import { convertDateToString } from "../../utility/ConvertUtily";
import Button from "../../components/button/Button";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { exportLogging } from "../../api/exportLogging";
import { requestManagePointAuth } from "../../api/Companies.api";
import { SessionKey } from "../../config/const";

type Items = {
  metaData: FullMetadata;
  fileName: string;
  filePath: string;
  downloadUrl: string;
  createdAt: Date;
  updateAt: Date;
}

export const UsageSituation = () => {
  const [report, setReport] = useState<string>('');
  const [rows, setRows] = useState<GridRow[]>([]);
  const [cols, setCols] = useState<GridCol[]>([]);

  const dispatch = useDispatch();

  // ログイン中のユーザー情報
  const currentUser = auth.currentUser;

  const radioItem: RadioButtonItem[] = [
    {
      id: "possession",
      title: "あり",
    },
    {
      id: "none",
      title: "なし",
    },
  ];
  const select = useInput("possession");

  useEffect(() => {
    const f = async () => {
      const path = report;
      const storageRef = ref(storage, `${currentUser?.tenantId}/${path}`);
      const list = await listAll(storageRef);
      const items: Items[] = await Promise.all(list.items.map(async (item) => {
        const itemRef = ref(storage, item.fullPath);
        const metaData: FullMetadata = await getMetadata(itemRef);
        const downloadUrl: string = await getDownloadURL(itemRef);
        return {
          metaData: metaData,
          fileName: item.name,
          filePath: item.fullPath,
          downloadUrl: downloadUrl,
          createdAt: new Date(metaData.timeCreated),
          updateAt: new Date(metaData.updated),
        }
      }));
      // 作成日の降順に並べ替える
      const sortItems = () => {
        return items.sort((a, b) => {
           return  a.createdAt < b.createdAt? 1 : -1;
        });
      };
      const matchString = select.value === 'possession' ? '_個人情報あり' : '_個人情報なし'
      const rowsTemp: GridRow[] = sortItems().filter((item) => report !== 'readcount' ? item.fileName.match(matchString) : true)
      .map((item): GridRow => {
        return {
          rowData: {
            month: item.fileName.substring(item.fileName.lastIndexOf('_') + 1, item.fileName.lastIndexOf('.xlsx')),
            createdAt: convertDateToString(item.createdAt),
            download: (<Button onClick={() => onDownload(item)} children={"ダウンロードする"} />),
            fileName: item.fileName,
        }}
      }) ?? [];
      const text = report === ''
        ? 'レポート種別を選択してください。'
        : 'ファイルが作成されていません。';
      const rows = rowsTemp.length > 0 ? rowsTemp : [{rowData: { createdAt: text}}];
      setRows(rows);
      const cols: GridCol[] = [
        {
          field: 'fileName',
          headerName: 'ファイル名',
          style: ''
        },
        {
          field: 'createdAt',
          headerName: '作成日',
          style: ''
        },
        {
          field: 'download',
          headerName: 'ダウンロード',
          style: '',
          sort: false
        }
      ];
      if(report !== 'access'){
        setCols([...[{
          field: 'month',
          headerName: '集計月',
          style: ''
        }], ...cols]);
      } else {
        setCols(cols);
      }
    };
    f();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentUser?.tenantId, report, select.value]);


  const reportItem = [
    { id: '', name: ''},
    { id: 'access', name: '一定期間操作がなかった利用者' },
    { id: 'step', name: '歩数情報' },
    { id: 'movie', name: '動画アクセス数' },
    { id: 'menu', name: 'トップメニューアクセス数' },
    { id: 'reply', name: '返信ボタン（お知らせ）' },
    { id: 'readcount', name: '既読・未読（全体の傾向）' },
  ];

  if (sessionStorage.getItem(SessionKey.MANAGE_POINT_AUTH) === 'true') {
    reportItem.push({ id: 'point', name: 'ポイント数' });
  }

  const onDownload = async (item: Items) => {
    // ダウンロードリンク
    const response = await fetch(item.downloadUrl, {mode: 'cors'});
    const blob = await response.blob();
    const newBlob = new Blob([blob]);
    const objUrl = window.URL.createObjectURL(newBlob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = item.fileName;
    a.click();
    a.remove();
    const date = new Date();
    const data = { "log_level": "info", "app_name": "webapp", "is_audit": true, "dawnload_date": new Date(date.getTime() + (9 * 60 * 60 * 1000)), "dawnload_user": currentUser?.email, "tenant_id": currentUser?.tenantId, "download_filename": a.download, "message": "利用状況Excelファイルダウンロード実行" }
    exportLogging(data);
    if(response.ok){
      dispatch(alertOpen(AlertValue(`${item.fileName}をダウンロードしました。`, "primary")));
    }
  }

  return (
    <div className="h-full">
      <div className="flex items-center p-6">
        <div className="flex-auto">
          <h1 className="text-xl  font-semibold text-gray-900">利用状況</h1>
        </div>
      </div>
      <div className={"flex flex-col space-y-6 px-6"}>
        <SelectFields
          label={"レポート種別"}
          id="report"
          value={report}
          className={'w-1/3'}
          onChange={(e: any) => {
            setReport(e.target.value);
          }}
          selectItems={reportItem?.map((item) => {
            return {
              id: item.id,
              name: item.name
            }
          })}
        />
        {report !== 'readcount' ? (<>
          <RadioButton
            vertical
            label={'個人情報掲載'}
            children={undefined}
            className={'w-1/3'}
            value={select}
            name={"団体全員"}
            radioButtonItem={radioItem}
          />
        </>) : (<></>)}
        <div>
          <TableList header gridRow={rows} gridCol={cols} />
        </div>
      </div>
    </div>
  );
};
